import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Tipo } from '../../model/tipo';
import { TipoService } from '../../services/tipo.service';

@Component({
  selector: 'app-tipo-unidad-cobro',
  templateUrl: './tipo-unidad-cobro.component.html',
  styleUrls: ['./tipo-unidad-cobro.component.css']
})

export class TipoUnidadCobroComponent implements OnInit {

  @Output() tipoSeleccionado: String;
  @Input() fields: Tipo[];
  @Input() fieldSelect: string;
  @Output() selectEvent = new EventEmitter();


  public seleccionActual: String;

  constructor(
    private _tipoService: TipoService
  ) { }

  ngOnInit() {
     if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
    this.getTipos();
  }


  getTipos() {
    this._tipoService.getTipos()
      .subscribe(
      data => {
        this.fields = data.filter(a => a.tipo === "PRESENTACIONEMPAQUE");
      },
      err => {
        console.log(err);
      });
  }

  onSelected(valor: any) {
    this.tipoSeleccionado = valor;
    this.selectEvent.emit(this.tipoSeleccionado);
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/tipo-unidad-cobro/tipo-unidad-cobro.component.ts